import { render } from "./App.vue?vue&type=template&id=70ca45a0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=70ca45a0&lang=scss"
script.render = render

export default script